/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '../request';
/**
 * @description test
 */

export function hdprojectproductInfo(data) {
  return request.get("/hd/hdprojectproduct/info/".concat(data));
}
/**
 * @description 配件申请
 */

export function getCostAccessoryGetList(data) {
  return request.get("/costAccessory/getList", {
    params: data
  });
}
/**
 * @description 费用报销
 */

export function getCostAccessoryList(data) {
  return request.get("/costAccessory/list", {
    params: data
  });
}